import React from "react";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import DtvGrid from "@directv-digital/dds.ui.dtv-grid";
import DtvText from "@directv-digital/dds.ui.dtv-text";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import DtvButton from "@directv-digital/dds.ui.dtv-button";
import DtvDivider from "@directv-digital/dds.ui.dtv-divider";
import { Card, CardContent } from "@mui/material";
import { Analytics } from "@directv-digital/dds.services.analytics-service";

export interface SiteMapProps {
  id?: any;
  analytics?: Analytics;
  data?: any;
  configuration?: any;
  heading?: any;
  forestHeading?: any;
  list?: any;
  isLightTheme?: boolean;
  logoUrl?: any;
  isIconVisible?: boolean;
  showDivider?: boolean;
}

export const SiteMap = (props: SiteMapProps) => {
  try {
    const {
      id,
      forestHeading,
      list
    } = props;

    return (
      <React.Fragment>
        {props && (
          <DtvBox
            id={id}
            sx={{
              maxWidth: "1200px",
              backgroundColor: "#f5f5f5",
              margin: "0 auto",
              padding: "16px"
            }}
          >
            <DtvText
              variant="subhead1medium"
              component="h2"
              sx={{
                color: "#102641",
                marginBottom: "32px",
                alignSelf: "center"
              }}
              {...forestHeading}
            />
            <DtvDivider sx={{ marginBottom: "20px" }} />
              {list?.map((ele, index) => {
                const totalLinks = ele?.linksList.length;
                const midPoint = Math.ceil(totalLinks / 2);
                const firstColumnLinks = ele?.linksList.slice(0, midPoint);
                const secondColumnLinks = ele?.linksList.slice(midPoint);

                return (
                  <DtvGrid
                    container
                    spacing={4}
                    key={index}
                  >
                    <DtvGrid
                      item
                      xs={12}
                      sm={6}
                      md={6}
                    >
                      {firstColumnLinks.map((each, colIndex) => (
                        <Card
                          sx={{
                            backgroundColor: "#ffffff",
                            borderRadius: "10px",
                            boxShadow: 1,
                            marginBottom: "16px"
                          }}
                          key={colIndex}
                        >
                          <CardContent
                            sx={{
                              padding: {
 xs: "16px",
sm: "20px",
md: "24px"
}
                            }}
                          >
                            <DtvText
                              variant="body2medium"
                              component="h4"
                              marginBottom="10px"
                              sx={{
                                color: "#102641"
                              }}
                              {...each?.sectionHeading}
                            />
                            <List
                              sx={{
                                padding: 0,
                                margin: 0,
                                listStyleType: "none"
                              }}
                            >
                              {each?.links.map((item, linkIndex) => (
                                <ListItem
                                  role="listitem"
                                  sx={{
                                    padding: 0,
                                    marginBottom: "8px"
                                  }}
                                  key={linkIndex}
                                >
                                  <DtvButton
                                    variant="uxtext"
                                    component="a"
                                    targeturl={item?.url}
                                    target={item?.target}
                                    label={
                                      <DtvText
                                        content={item.label}
                                        sx={{
                                          color: "#2E70BD",
                                          "&:hover": {
                                            textDecoration: "underline"
                                          }
                                        }}
                                        variant="body2"
                                      />
                                    }
                                    sx={{
                                      textDecoration: "none",
                                      userSelect: "text"
                                    }}
                                  />
                                </ListItem>
                              ))}
                            </List>
                          </CardContent>
                        </Card>
                      ))}
                    </DtvGrid>
                    <DtvGrid
                      item
                      xs={12}
                      sm={6}
                      md={6}
                    >
                      {secondColumnLinks.map((each, colIndex) => (
                        <Card
                          sx={{
                            backgroundColor: "#ffffff",
                            borderRadius: "10px",
                            boxShadow: 1,
                            marginBottom: "16px"
                          }}
                          key={colIndex}
                        >
                          <CardContent
                            sx={{
                              padding: {
 xs: "16px",
sm: "20px",
md: "24px"
}
                            }}
                          >
                            <DtvText
                              variant="body2medium"
                              component="h4"
                              marginBottom= "10px"

                              sx={{
                                color: "#102641"
                              }}
                              {...each?.sectionHeading}
                            />
                            <List
                              sx={{
                                padding: 0,
                                margin: 0,
                                listStyleType: "none"
                              }}
                            >
                              {each?.links.map((item, linkIndex) => (
                                <ListItem
                                  role="listitem"
                                  sx={{
                                    padding: 0,
                                    marginBottom: "8px"
                                  }}
                                  key={linkIndex}
                                >
                                  <DtvButton
                                    variant="uxtext"
                                    component="a"
                                    targeturl={item?.url}
                                    target={item?.target}
                                    label={
                                      <DtvText
                                        content={item.label}
                                        sx={{
                                          color: "#2E70BD",
                                          "&:hover": {
                                            textDecoration: "underline"
                                          }
                                        }}
                                        variant="body2"
                                      />
                                    }
                                    sx={{
                                      textDecoration: "none",
                                      userSelect: "text"
                                    }}
                                  />
                                </ListItem>
                              ))}
                            </List>
                          </CardContent>
                        </Card>
                      ))}
                    </DtvGrid>
                  </DtvGrid>
                );
              })}
          </DtvBox>
        )}
      </React.Fragment>
    );
  } catch (error) {
    return <ErrorDisplay error={error} />;
  }
};
